import { Link } from "react-router-dom";
import { Check, ArrowUpRight } from "lucide-react";
import { LIBRARIES_BULLETS } from "../../lib/site";

export default function Libraries() {
  return (
    <section
      data-testid="libraries-section"
      className="bg-[#F8F9FA] border-y-2 border-[#1A1A1A] relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid opacity-40 pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-5 md:px-10 lg:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Copy first (alternates layout) */}
          <div className="lg:col-span-7 order-2 lg:order-1">
            <p className="font-mono text-xs tracking-[0.25em] uppercase text-[#FF007F]">
              For Libraries &amp; Councils
            </p>
            <h2 className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tighter">
              Turn your library makerspace into a{" "}
              <span className="bg-[#FF007F] text-white px-2 inline-block">
                community
              </span>{" "}
              learning hub.
            </h2>
            <p className="mt-5 text-base md:text-lg text-[#4A4A4A] font-medium leading-relaxed max-w-xl">
              Libraries are becoming the new front door to lifelong learning.
              We help libraries and councils activate makerspaces, run engaging
              programs, train staff and build community learning pathways.
            </p>

            <ul className="mt-7 grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-xl">
              {LIBRARIES_BULLETS.map((b) => (
                <li
                  key={b}
                  className="flex items-start gap-3 bg-white border-2 border-[#1A1A1A] rounded-xl px-3 py-2.5"
                >
                  <span className="mt-0.5 inline-flex h-5 w-5 items-center justify-center rounded-md bg-[#FF007F] text-white">
                    <Check size={14} strokeWidth={3} />
                  </span>
                  <span className="text-sm font-semibold">{b}</span>
                </li>
              ))}
            </ul>

            <Link
              to="/contact"
              data-testid="libraries-cta-btn"
              className="mt-9 inline-flex items-center gap-2 bg-[#FF007F] text-white border-2 border-[#1A1A1A] rounded-full px-6 py-3.5 font-bold uppercase text-sm tracking-wide nb-shadow nb-press"
            >
              Partner With Us <ArrowUpRight size={16} strokeWidth={2.5} />
            </Link>
          </div>

          {/* Visual */}
          <div className="lg:col-span-5 order-1 lg:order-2 relative">
            <div className="relative aspect-[4/5] max-w-md mx-auto">
              <div className="absolute inset-0 rounded-3xl nb-border-thick nb-shadow-lg overflow-hidden bg-[#00C2B8]" />
              {/* circuit pattern */}
              <svg
                className="absolute inset-4 w-[calc(100%-32px)] h-[calc(100%-32px)] text-[#1A1A1A]/30"
                viewBox="0 0 200 250"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M10 30 H80 V70 H140 V20 H190" />
                <path d="M10 110 H50 V160 H120 V120 H190" />
                <path d="M10 200 H100 V230 H190" />
                <circle cx="80" cy="30" r="4" fill="currentColor" />
                <circle cx="140" cy="70" r="4" fill="currentColor" />
                <circle cx="50" cy="110" r="4" fill="currentColor" />
                <circle cx="120" cy="160" r="4" fill="currentColor" />
                <circle cx="100" cy="200" r="4" fill="currentColor" />
              </svg>
              {/* floating program cards */}
              <div
                className="absolute left-5 top-8 w-44 rounded-2xl bg-[#FFD700] border-2 border-[#1A1A1A] p-3 nb-shadow"
                style={{ transform: "rotate(-3deg)" }}
              >
                <p className="font-mono text-[10px] uppercase tracking-widest">
                  Holiday Program
                </p>
                <p className="mt-1 font-display font-black text-lg leading-tight">
                  Robotics Camp
                </p>
                <p className="mt-1 text-xs font-semibold">9–14 yrs · 4 days</p>
              </div>
              <div
                className="absolute right-4 top-32 w-44 rounded-2xl bg-white border-2 border-[#1A1A1A] p-3 nb-shadow"
                style={{ transform: "rotate(4deg)" }}
              >
                <p className="font-mono text-[10px] uppercase tracking-widest text-[#FF007F]">
                  Staff Training
                </p>
                <p className="mt-1 font-display font-black text-lg leading-tight">
                  Maker confidence
                </p>
                <div className="mt-2 flex gap-1">
                  <span className="h-1.5 w-6 bg-[#FF007F] rounded-full" />
                  <span className="h-1.5 w-4 bg-[#0055FF] rounded-full" />
                  <span className="h-1.5 w-2 bg-[#FFD700] rounded-full" />
                </div>
              </div>
              <div
                className="absolute left-10 bottom-6 w-48 rounded-2xl bg-[#1A1A1A] text-white border-2 border-[#1A1A1A] p-3 nb-shadow"
                style={{ transform: "rotate(-2deg)" }}
              >
                <p className="font-mono text-[10px] uppercase tracking-widest text-[#FFD700]">
                  Community
                </p>
                <p className="mt-1 font-display font-black text-lg leading-tight">
                  Youth Innovation Lab
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
